import { SearchTerm } from '../utils/constants';
import { DealTypeEnum, SortType } from './endpoints';
import { AuctionTypes, CarConditions } from './models';

export type NonEmptyArray<T> = [T, ...T[]];

export type FiltersState = {
  body_style?: string;
  cityEco?: number[];
  completed?: boolean;
  condition?: CarConditions | 'any';
  discount?: number;
  distance?: number;
  drivetrain?: string;
  exterior_color?: string;
  fuel_type?: string;
  hwyEco?: number[];
  interior_color?: string;
  make?: string;
  maxMonthlyPayment?: number;
  miles?: number;
  minMonthlyPayment?: number;
  model?: string;
  msrp?: number[];
  offset?: number;
  perPage?: number;
  premium?: NonEmptyArray<string>;
  feature?: NonEmptyArray<string>;
  sortType?: SortType;
  term?: SearchTerm;
  transmission?: string;
  trim?: string;
  type?: AuctionTypes;
  wheel_type?: NonEmptyArray<string>;
  year?: number;
  zipcode?: string;
  creditScore?: number;
  is_featured?: boolean;
  tariff_free_deals?: boolean;
  dealType?: DealTypeEnum;
};

// filter tags
export type SelectedCustomFilterState = {
  monthlyBudget: [number, number];
};
export type SelectedFilterCategory = keyof FiltersState;
export type SelectedCustomFilterCategory = keyof SelectedCustomFilterState;

export const EXCLUDED_FILTERS_CATEGORY_LIST: SelectedFilterCategory[] = [
  'completed',
  'distance',
  'offset',
  'perPage',
  'sortType',
  'term',
  'zipcode',
  'miles',
  'creditScore',
  // next filter categories handled manually
  'premium',
  'feature',
  'minMonthlyPayment',
  'maxMonthlyPayment',
  'is_featured',
  'tariff_free_deals',
  'dealType',
];

export type SelectedFilterChipParams = {
  category: SelectedFilterCategory | SelectedCustomFilterCategory;
  value:
    | FiltersState[SelectedFilterCategory]
    | SelectedCustomFilterState[SelectedCustomFilterCategory];
  overwriteLabel?: [string, string];
};

export type IncentiveCategory = {
  ID: number;
  Name: string;
  CategoryID?: number;
  SubcategoryID?: number;
};

export type RebateCategoryQuestion = {
  title: string;
  categories: {
    categoryName: string;
    subcategoriesNames?: string[];
  }[];
};

export type RebateCategoryAnswer = Pick<RebateCategoryQuestion, 'title'> & {
  isApplied: boolean;
};

export type SitemapFeature = { feature_name: string; feature_type: string };
export type SitemapBodyType = { body_type: string };
export type SitemapModelMake = { model_name: string; make_name: string };

export type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
    ? RecursivePartial<U>[]
    : T[P] extends object
    ? RecursivePartial<T[P]>
    : T[P];
};

export interface Identity {
  email: string;
  password?: string;
  phone?: string;
}
